import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import BasicLayout from '@/layouts/BasicLayout';

/**
 * 活动-模块
 */
var activity = {
  path: '/activity',
  component: BasicLayout,
  redirect: '/activity/Share',
  children: [{
    path: '/activity/exchange',
    name: 'VoteExchange',
    component: function component() {
      return import('views/activity/vote/Exchange');
    },
    meta: {
      title: '兑换权益'
    }
  }, {
    path: '/activity/vote',
    name: 'VoteIndex',
    component: function component() {
      return import('views/activity/vote/Index');
    },
    meta: {
      title: '投票详情'
    }
  }, {
    path: '/activity/votingChannel',
    name: 'VotingChannel',
    component: function component() {
      return import('views/activity/vote/VotingChannel');
    },
    meta: {
      title: '助力通道'
    }
  }, {
    path: '/activity/votingResults',
    name: 'VotingResults',
    component: function component() {
      return import('views/activity/vote/VotingResults');
    },
    meta: {
      title: '投票结果'
    }
  },
  // 抽奖 在使用2023.1.13 start
  {
    path: '/activity/lottery',
    name: 'ActivityLottery',
    component: function component() {
      return import('views/activity/lottery/Index');
    },
    meta: {
      title: '抽奖',
      hasAppHead: true
    }
  }, {
    path: '/activity/lotteryPoster',
    name: 'ActivityLotteryPoster',
    component: function component() {
      return import('views/activity/lottery/Poster');
    },
    meta: {
      title: '分享海报',
      hasAppHead: true
    }
  }, {
    path: '/activity/lotteryRule',
    name: 'ActivityLotteryRule',
    component: function component() {
      return import('views/activity/lottery/Rule');
    },
    meta: {
      title: '活动规则',
      hasAppHead: true
    }
  }, {
    path: '/activity/lotteryPrize',
    name: 'ActivityLotteryPrize',
    component: function component() {
      return import('views/activity/lottery/Prize');
    },
    meta: {
      title: '我的奖品',
      hasAppHead: true
    }
  }, {
    path: '/activity/lotterySmeltingNFR',
    name: 'ActivityLotterySmeltingNFR',
    component: function component() {
      return import('views/activity/lottery/SmeltingNFR');
    },
    meta: {
      title: '选择熔炼NFR',
      hasAppHead: true
    }
  }, {
    path: '/activity/lotteryConfirmSmelt',
    name: 'ActivityLotteryConfirmSmelt',
    component: function component() {
      return import('views/activity/lottery/ConfirmSmelt');
    },
    meta: {
      title: '熔炼抽奖',
      hasAppHead: true
    }
  }, {
    path: '/activity/lotteryAuth',
    name: 'ActivityLotteryAuth',
    component: function component() {
      return import('views/activity/lottery/Auth');
    },
    meta: {
      title: '安全认证',
      hasAppHead: true
    }
  }, {
    path: '/activity/lotteryRecord',
    name: 'ActivityLotteryRecord',
    component: function component() {
      return import('views/activity/lottery/Prize');
    },
    meta: {
      title: '奖励记录',
      hasAppHead: true
    }
  },
  // 抽奖 在使用2023.1.13 end
  // 扫码领取盲盒 在使用2023.1.13 start
  {
    path: '/activity/drawBlindBox',
    name: 'ActivityDrawBlindBox',
    component: function component() {
      return import('views/activity/drawBlindBox/Index');
    },
    meta: {
      title: '领取盲盒'
    }
  },
  // 扫码领取盲盒 在使用2023.1.13 end

  // 邀请有礼 start
  {
    path: '/activity/inviteGift',
    name: 'InviteGift',
    component: function component() {
      return import('views/activity/InviteGift/Index');
    },
    meta: {
      title: '邀请有礼'
    }
  }, {
    path: '/activity/inviteGiftPoster',
    name: 'InviteGiftPoster',
    component: function component() {
      return import('views/activity/InviteGift/Poster');
    },
    meta: {
      title: '分享海报'
    }
  }, {
    path: '/activity/inviteGiftLandingPage',
    name: 'InviteGiftLandingPage',
    component: function component() {
      return import('views/activity/InviteGift/LandingPage');
    },
    meta: {
      title: '邀请有礼'
    }
  }]
};
export default activity;